import angular from "angular";
import { angularizeReactComponents } from "./react-adapter.angularize";
import { ReactAdapterService } from "./react-adapter.service";

export function registerReactAdapterModule() {
  angularizeReactComponents();

  angular.module("dashboard").service("reactAdapterService", ReactAdapterService);
}
